import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import { ArrowBackIcon } from "~/Components/Icons/Icons";
import { adminHttp } from "~/Admin/services/http";
import { humanFileSize } from '~/helpers/utils';
import { CircularProgressbar } from 'react-circular-progressbar';
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import { connect } from "react-redux";
import { toast } from 'react-toastify';

const AdminValidate = ({ match, event, ...props }) => {

    const [validation, setValidation] = useState('');
    const [showNotification, setShowNotification] = useState(false)

    const loadData = () => {
        adminHttp
            .get('/events/' + event.id + '/validations/' + match.params.id)
            .then(res => {
                if(showNotification && res.data.status === 'import_ok') {
                    toast.success('Guests successfuly imported.')
                }
                if(showNotification && res.data.status === "import_error") {
                    toast.error('There has been error while importing guests.')
                }
                setShowNotification(false);
                setValidation(res.data);
            })
            .catch((err) => {
                toast.error('Something went wrong while loading data!')
            })
    };

    const handleImport = () => {
        adminHttp.post('/events/' + event.id + '/validations/' + match.params.id + '/import')
            .then((res)=> {
                setShowNotification(true);

                if(res.data.status === "import_progress") {
                    toast.info('Importing...');
                }

                setValidation(res.data);
            })
            .catch((err)=>{
                toast.error('Something went wrong!')
            })
    };

    useEffect(loadData, [event]);

    useEffect(() => {

        const interval = setInterval(() => {

            if (['pending', 'validation_progress', 'import_progress'].includes(validation.status)) {
                loadData();
            }

        }, 1000);

        return () => {
            clearInterval(interval);
        }

    }, [validation]);

    if (!validation) {
        return <></>;
    }

    return (
        <div className="validate-data">

            <Link to="/guests/invitation/validate" className="btn btn-secondary btn-sm mb-4">
                <ArrowBackIcon classes="d-inline mr-2" />
                Back
            </Link>

            <h2>Data Validation</h2>

            <div className="row">

                <div className="col-xl-3 col-lg-12">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <h3 className="text-primary">File Upload</h3>
                            <p>
                                Your file <strong>{validation.name} ({humanFileSize(validation.size)})</strong> has been uploaded.
                            </p>
                            <p>
                                <Link to="/guests/invitation/validate">
                                    Upload a new file
                                </Link>
                            </p>

                            <div className="row">
                                <div className="col-6">Status</div>
                                <div className="col-6">{validation.status}</div>
                            </div>

                            <div className="row">
                                <div className="col-6">Total Rows</div>
                                <div className="col-6">{validation.row_count}</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-xl-9 col-lg-12">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <h3 className="text-primary">Data Validation</h3>


                            <div className="row">
                                <div className="col-3">
                                    <CircularProgressbar
                                        value={validation.progress}
                                        maxValue={validation.row_count}
                                        strokeWidth={4}
                                        styles={{
                                            path: {
                                                stroke: '#EBC03F',
                                            },
                                            text: {
                                                fill: '#EBC03F',
                                            }
                                        }}
                                        text={validation.progress} />
                                </div>
                                <div className="col-9">
                                    {validation.validation_errors && Object.keys(validation.validation_errors).map((group, index) => {
                                        return (
                                            <div className="validation-errors" key={index}>
                                                <h3 className="text-secondary text-uppercase">{group}</h3>
                                                {validation.validation_errors[group].map((err, index) => (
                                                    <div className="text-danger" key={index}>{err}</div>
                                                ))}
                                            </div>
                                        )
                                    })}

                                    {validation.import_errors && (
                                        <div className="validation-errors">
                                            <h3 className="text-secondary text-uppercase">
                                                <div className="text-danger">{validation.import_errors}</div>
                                            </h3>
                                        </div>
                                    )}

                                    {validation.status === 'validation_ok' && (
                                        <div>
                                            <div className="alert alert-success" role="alert">
                                                Success! File has no errors.
                                            </div>

                                            <ConfirmedButton
                                                confirmText="Are you sure you want to import all the guests ?"
                                                onClick={handleImport}
                                                className="btn btn-primary text-cta float-right">
                                                Import Guests
                                            </ConfirmedButton>

                                        </div>
                                    )}

                                    {validation.status === 'import_ok' && (
                                        <div>
                                            <div className="alert alert-success" role="alert">
                                                Success! Guests have been imported.
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminValidate);
